import { StyledFormGroup } from "@components/formGroup";
import { StyledFieldContent } from "@components/inputs/field/Field.styles";
import { StyledSwitch } from "@components/inputs/switch/Switch.styles";
import styled from "styled-components";

import { T_TITLE_2 } from "../../global.style";
import { SmartHeaderStyled } from "../../views/formView/FormView.styles";

export const StepSubtitle = styled.div`
    ${T_TITLE_2};
    margin-bottom: 38px;
`;

export const HeaderStyled = styled(SmartHeaderStyled)`
    padding-bottom: 28px;
`;

export const NewCustomerFormStyled = styled.div`
    ${StyledFormGroup}:has(${StyledSwitch}) {
        margin-bottom: 13px;
    }
    
    ${StyledFieldContent}:has(${StyledSwitch}) { 
        padding-left: 0;
    }
`;